module.exports = __webpack_public_path__ + "static/img/14000414.2334d44f.png";